export const COMPANY_SAVED_BROKERS_INLINE_RESPONSES: Record<string, unknown[]> =
  {
    "/apollo/companies/get-saved-brokers-for-company": [
      {
        savedBrokerId: "0b6f6a53-5a0e-4b7a-9d57-6c1f2f0a1a01",
        companyId: "6c1c3c47-ed46-4995-9ca9-a2a8b0a48d24",
        broker: {
          businessName: "Livingston International",
          accountNumber: "LIV-48213",
          contact: {
            contactName: "Maria Chen",
            emailAddress: "maria.chen@livingstonintl.com",
            phoneNumber: "(905) 555-0142",
          },
          address: {
            addressLine: "405 The West Mall",
            city: "Toronto",
            stateOrProvinceCode: "ON",
            postalCode: "M9C 5K7",
          },
        },
      },
    ],
  };
